module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/1-7d689255ae541bb956806daeb0eac31d.png";